<template>
  <v-row no-gutters>
    <NewLayoutSelect :selectedSection="selectedSection"/>
    <NewLayoutDialog :selectedSection="selectedSection"/>
    <NewLayoutConfig :selectedSection="selectedSection"/>    

    <Expansion v-model="styleExpansion.common" :verticalExpansion="false" defaultClass="pt-4">
      <template slot="default">
        <ExpandedIcon :isExpanded="styleExpansion.common"/>
        <span class="pl-2 _subtitleFormFont">
          <b>Personalizar estilo</b>
        </span>
      </template>

      <template slot="expanded">
        <v-row no-gutters class="pt-4">
          <v-col cols="6" class="_pr-">
            <TextField 
              v-model="layout.width"
              label="Largura ingresso"
              type="number"
              :minValueForNumber="width"
              appendIcon="fa-solid fa-xmark"
              appendIconTooltip="Resetar para largura padrão"
              @appendClick="handleReset('width')"
            />
          </v-col>

          <v-col cols="6"></v-col> 

          <v-col cols="6" class="_pt _pr-">
            <ColorPickerV2 title="Cor de fundo" :colorSelected="layout" type="bgColor" defaultColor="#00000000"/> 
          </v-col>  

          <v-col cols="6" class="_pt _pl-">
            <ColorPickerV2 title="Cor de fundo2" :colorSelected="layout" type="itemBgColor" defaultColor="#FFFFFF"/> 
          </v-col>     

          <v-col cols="6" class="_pt _pr-">
            <ColorPickerV2 title="Cor preço" :colorSelected="layout" type="accentColor2" defaultColor="#0079CB"/> 
          </v-col>

          <v-col cols="6" class="_pt _pl-">
            <ColorPickerV2 title="Cor botão" :colorSelected="layout.btnColor1" type="bg" defaultColor="#0A9AED"/> 
          </v-col>

          <v-col cols="6" class="_pt _pr-">
            <ColorPickerV2 title="Cor texto botão" :colorSelected="layout.btnColor1" type="text" defaultColor="#FFFFFF"/> 
          </v-col>

          <v-col cols="6" class="_pt _pl-">
            <ColorPickerV2 title="Cor ingresso" :colorSelected="layout" type="textColor1" defaultColor="#000000"/> 
          </v-col>

          <v-col cols="6" class="_pt _pr-">
            <ColorPickerV2 title="Cor de texto 2" :colorSelected="layout" type="textColor2" defaultColor="#ACACAC"/> 
          </v-col>

          <v-col cols="6" class="_pt _pl-">
            <ColorPickerV2 title="Cor linhas" :colorSelected="layout" type="accentColor1" defaultColor="#EDEDF1"/> 
          </v-col>

          <v-col cols="6" class="_pt _pr-">
            <ColorPickerV2 title="Cor texto item" :colorSelected="layout" type="itemColor" defaultColor="#055387"/> 
          </v-col>  

          <v-col cols="6"></v-col>

          <v-col cols="6" class="pt-5 _pr-">
            <ColorPickerV2 title="Cor fundo item incluso" :colorSelected="layout.checkColor1" type="bgChecked" defaultColor="#0A9AED" smallFont/> 
          </v-col>  

          <v-col cols="6" class="pt-5 _pl-">
            <ColorPickerV2 title="Cor item incluso" :colorSelected="layout.checkColor1" type="colorChecked" defaultColor="#FFFFFF" smallFont/> 
          </v-col>     

          <v-col cols="6" class="_pt _pr-">
            <ColorPickerV2 title="Cor item não incluso" :colorSelected="layout.checkColor1" type="colorNotChecked" defaultColor="#ACACAC" smallFont/> 
          </v-col>                      
        </v-row>
      </template>
    </Expansion>

    <Expansion v-model="styleExpansion.highlight" :verticalExpansion="false" defaultClass="pt-4">
      <template slot="default">
        <ExpandedIcon :isExpanded="styleExpansion.highlight"/>
        <span class="pl-2 _subtitleFormFont">
          <b>Personalizar ingresso destaque</b>
        </span>
      </template>

      <template slot="expanded">
        <v-row no-gutters class="pt-4">
          <v-col cols="6" class="_pr-">
            <TextField 
              v-model="layout.featuredWidth"
              label="Largura ingresso destaque"
              type="number"
              :minValueForNumber="featuredWidth"
              smallFontLabel
              appendIcon="fa-solid fa-xmark"
              appendIconTooltip="Resetar para largura padrão"
              @appendClick="handleReset('featuredWidth')"              
            />            
          </v-col> 

          <v-col cols="6"></v-col> 

          <v-col cols="6" class="_pt _pr-">
            <ColorPickerV2 title="Cor destaque 1" :colorSelected="layout" type="featuredBgColor1" defaultColor="#0A4470"/> 
          </v-col>
          
          <v-col cols="6" class="_pt _pl-">
            <ColorPickerV2 title="Cor preço destaque" :colorSelected="layout" type="priceColor" defaultColor="#FFFFFF"/> 
          </v-col>

          <v-col cols="6" class="_pt _pr-">
            <ColorPickerV2 title="Cor botão" :colorSelected="layout.btnColor2" type="bg" defaultColor="#FFAA33"/> 
          </v-col>

          <v-col cols="6" class="_pt _pl-">
            <ColorPickerV2 title="Cor texto botão" :colorSelected="layout.btnColor2" type="text" defaultColor="#FFFFFF"/> 
          </v-col>
        </v-row>
      </template>
    </Expansion>          
  </v-row>
</template>

<script>
import ColorPickerV2 from '../../../../_v2/ui/ColorPickerV2.vue'
import Expansion from '../../../../_v2/ui/Expansion.vue'
import ExpandedIcon from '../../../../_v2/utils/ExpandedIcon.vue'
import NewLayoutSelect from './newLayoutsSelect.vue'
import NewLayoutDialog from './newLayoutsDialog.vue'
import NewLayoutConfig from './newLayoutsConfig.vue'
import TextField from '../../../../_v2/ui/TextField.vue'
import { TICKETS_GET_DEFAULT_WIDTH } from '../../../../../schemas/sections'

export default {
  name: 'newLayout6',
  components: {ColorPickerV2, NewLayoutSelect, NewLayoutDialog, Expansion, ExpandedIcon, NewLayoutConfig, TextField},
  props: {
    selectedSection: {type: Object, required: true}
  },
  computed: {
    layout () {
      return this.selectedSection.layoutStyle.newLayout6
    }
  },

  mounted () {
    setTimeout(() => { this.styleExpansion = {common: false, highlight: false} })
  },  

  data: () => ({
    styleExpansion: {common: true, highlight: true},
    width: TICKETS_GET_DEFAULT_WIDTH('newLayout6').width,
    featuredWidth: TICKETS_GET_DEFAULT_WIDTH('newLayout6').featuredWidth  
  }),

  methods: {
    handleReset (type) {
      if (type === 'width') this.layout.width = this.width
      if (type === 'featuredWidth') this.layout.featuredWidth = this.featuredWidth
    }
  }   
}
</script>

<style scoped>
</style>